import styled from "styled-components";

export const CollapseWrapper = styled.div`
.custom-collapse {
  border-radius: 4px;
  overflow: hidden;
}
.ant-collapse-content-box{
  padding: 0;
}
.left-collapse-able {
  border: 1px solid #ECEFF1;
  border-radius: 5px;
  .ant-collapse-content.ant-collapse-content-active{
    border: none !important;
  }
  .ant-collapse-header{
    padding: 10px 12px !important;
    padding-left: 24px !important;
    background-color: #ECEFF1 !important;
  }
  .ant-collapse.ant-collapse-icon-position-left.custom-collapse{
  border:none;
}}
.ant-collapse-header{
font-weight: 600;
font-size: 14px;
line-height: 18px;
letter-spacing: 0%;
color: #535E63 !important;
padding: 2px 16px !important;
user-select: none;
background-color: #F4F6F6 !important;
border: none !important;
}
.card-content {
  background-color: #2f6fe7;
  padding: 16px 8px 6px;
  display: flex;
  align-items: flex-start;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  grid-gap: 29px;
}
.info {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  grid-row-gap: 4px;
  strong { 
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;
    color: #FFFFFF;
   }
  p{
    margin: 0;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    color: #E0E0E0;
  }
}
`;